// LNA Wheel - Spin Logic & Form Validation

// Wheel configuration
const WHEEL_CONFIG = {
  segments: 8,
  segmentAngle: 45, // 360 / 8
  prizes: [
    { id: 0, name: 'Shampoing offert', type: 'physical', icon: '🧴', text: 'SHAMPOING', weight: 0.001 },
    { id: 1, name: 'Accessoire offert', type: 'physical', icon: '🎀', text: 'ACCESSOIRE', weight: 0.002 },
    { id: 2, name: '-15% code LNA1', type: 'code', icon: '🎁', text: '-15%', subtext: 'LNA1', discount: '-15%', code: 'LNA1' },
    { id: 3, name: '-15% code LNA1', type: 'code', icon: '✨', text: '-15%', subtext: 'LNA1', discount: '-15%', code: 'LNA1' },
    { id: 4, name: '-15% code LNA1', type: 'code', icon: '🎁', text: '-15%', subtext: 'LNA1', discount: '-15%', code: 'LNA1' },
    { id: 5, name: '-15% code LNA1', type: 'code', icon: '✨', text: '-15%', subtext: 'LNA1', discount: '-15%', code: 'LNA1' },
    { id: 6, name: '-10% code LNA2', type: 'code', icon: '🎁', text: '-10%', subtext: 'LNA2', discount: '-10%', code: 'LNA2' },
    { id: 7, name: '-10% code LNA2', type: 'code', icon: '✨', text: '-10%', subtext: 'LNA2', discount: '-10%', code: 'LNA2' },
  ],
  colors: {
    beige: '#f5ece3',
    blue: '#dce8f5',
  },
  rotationDuration: 5000, // 5 seconds
  easingFunction: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)', // ease-out
};

// DOM elements
const formEl = document.getElementById('lna-form');
const prenomInput = document.getElementById('lna-prenom');
const emailInput = document.getElementById('lna-email');
const emailErrorEl = document.getElementById('lna-email-error');
const spinButton = document.getElementById('lna-spin-button');
const wheelSvg = document.getElementById('lna-wheel-svg');
const segmentsGroup = document.getElementById('lna-segments');
const modalOverlay = document.getElementById('lna-modal-overlay');
const modalElement = document.getElementById('lna-modal');
const modalContent = document.getElementById('lna-modal-content');
const modalCloseBtn = document.getElementById('lna-modal-close');
// IMPORTANT: Replace with actual Cloudflare Worker URL after deployment
// Format: https://mpl-lna-wheel.YOUR-SUBDOMAIN.workers.dev
const workerUrl = 'https://mpl-lna-wheel.alex-636.workers.dev';

// State
let isSpinning = false;
let currentRotation = 0;
let hasPlayed = false;

// localStorage keys
const STORAGE_KEY_PLAYED = 'lna_wheel_has_played';
const STORAGE_KEY_EMAIL = 'lna_wheel_email';
const STORAGE_KEY_PRIZE = 'lna_wheel_prize';

// Email validation regex
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Draw wheel segments
function renderWheelSegments() {
  const radius = 150;
  const centerX = 160;
  const centerY = 160;
  const textRadius = radius * 0.68;

  segmentsGroup.innerHTML = '';

  for (let i = 0; i < WHEEL_CONFIG.segments; i++) {
    const startAngle = (i * WHEEL_CONFIG.segmentAngle - 90) * (Math.PI / 180);
    const endAngle = ((i + 1) * WHEEL_CONFIG.segmentAngle - 90) * (Math.PI / 180);

    const x1 = centerX + radius * Math.cos(startAngle);
    const y1 = centerY + radius * Math.sin(startAngle);
    const x2 = centerX + radius * Math.cos(endAngle);
    const y2 = centerY + radius * Math.sin(endAngle);

    const largeArcFlag = WHEEL_CONFIG.segmentAngle > 180 ? 1 : 0;

    const pathData = [
      `M ${centerX} ${centerY}`,
      `L ${x1} ${y1}`,
      `A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2}`,
      'Z',
    ].join(' ');

    // Determine color (alternate beige and blue)
    const color = i % 2 === 0 ? WHEEL_CONFIG.colors.beige : WHEEL_CONFIG.colors.blue;

    // Path element
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', pathData);
    path.setAttribute('fill', color);
    path.setAttribute('stroke', 'rgba(0,0,0,0.1)');
    path.setAttribute('stroke-width', '1.5');
    segmentsGroup.appendChild(path);

    // Text element
    const textAngle = ((i + 0.5) * WHEEL_CONFIG.segmentAngle - 90) * (Math.PI / 180);
    const textX = centerX + textRadius * Math.cos(textAngle);
    const textY = centerY + textRadius * Math.sin(textAngle);
    const textRotation = (i + 0.5) * WHEEL_CONFIG.segmentAngle;
    const prize = WHEEL_CONFIG.prizes[i];

    const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    text.setAttribute('x', textX);
    text.setAttribute('y', textY);
    text.setAttribute('fill', '#000');
    text.setAttribute('font-size', '11');
    text.setAttribute('font-weight', '800');
    text.setAttribute('font-family', 'sans-serif');
    text.setAttribute('text-anchor', 'middle');
    text.setAttribute('dominant-baseline', 'middle');
    text.setAttribute('transform', `rotate(${textRotation}, ${textX}, ${textY})`);

    const iconLine = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
    iconLine.setAttribute('x', textX);
    iconLine.setAttribute('dy', prize.subtext ? '-1.05em' : '-0.58em');
    iconLine.setAttribute('font-size', '20');
    iconLine.textContent = prize.icon;
    text.appendChild(iconLine);

    const labelLine = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
    labelLine.setAttribute('x', textX);
    labelLine.setAttribute('dy', '1.25em');
    labelLine.textContent = prize.text;
    text.appendChild(labelLine);

    if (prize.subtext) {
      const subtextLine = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
      subtextLine.setAttribute('x', textX);
      subtextLine.setAttribute('dy', '1.05em');
      subtextLine.setAttribute('font-size', '10');
      subtextLine.textContent = prize.subtext;
      text.appendChild(subtextLine);
    }

    segmentsGroup.appendChild(text);
  }
}

// Validate form
function validateForm(showErrors = true) {
  const prenom = prenomInput.value.trim();
  const email = emailInput.value.trim();

  // Clear previous errors
  emailErrorEl.classList.remove('show');
  emailErrorEl.textContent = '';
  prenomInput.classList.remove('error');
  emailInput.classList.remove('error');

  // Validate prénom (non-empty)
  if (!prenom) {
    if (showErrors) {
      prenomInput.classList.add('error');
    }
    return false;
  }

  // Validate email (regex)
  if (!EMAIL_REGEX.test(email)) {
    if (showErrors) {
      emailErrorEl.textContent = 'Adresse e-mail invalide.';
      emailErrorEl.classList.add('show');
      emailInput.classList.add('error');
    }
    return false;
  }

  return true;
}

// Update button state
function updateButtonState() {
  const isValid = validateForm(false);
  spinButton.disabled = !isValid || hasPlayed;
}

formEl.addEventListener('input', updateButtonState);
emailInput.addEventListener('change', updateButtonState);
prenomInput.addEventListener('change', updateButtonState);

// Modal functions
function openModal() {
  modalOverlay.style.display = 'flex';
}

function closeModal() {
  modalOverlay.style.display = 'none';
  modalContent.innerHTML = '';
}

modalCloseBtn.addEventListener('click', closeModal);
modalOverlay.addEventListener('click', (e) => {
  if (e.target === modalOverlay) {
    closeModal();
  }
});

function selectPrizeSegment() {
  const physicalRoll = Math.random();
  const physicalPrizes = WHEEL_CONFIG.prizes.filter((prize) => prize.type === 'physical');
  const discountPrizes = WHEEL_CONFIG.prizes.filter((prize) => prize.type === 'code');
  let cumulativeWeight = 0;

  for (const prize of physicalPrizes) {
    cumulativeWeight += prize.weight || 0;
    if (physicalRoll < cumulativeWeight) {
      return prize.id;
    }
  }

  return discountPrizes[Math.floor(Math.random() * discountPrizes.length)].id;
}

// Spin wheel
function spinWheel() {
  if (isSpinning || !validateForm(true) || hasPlayed) {
    return;
  }

  isSpinning = true;
  spinButton.classList.add('spinning');
  spinButton.disabled = true;

  // Weighted segment: physical prizes stay rare while the discount is near-guaranteed.
  const segmentIndex = selectPrizeSegment();
  const prize = WHEEL_CONFIG.prizes[segmentIndex];
  const prenom = prenomInput.value.trim();
  const email = emailInput.value.trim();

  // Send to Mailchimp as soon as the participation is valid.
  sendToMailchimp(email, prenom, prize);

  // Random full rotations (5-8)
  const fullRotations = 5 + Math.floor(Math.random() * 4);

  // Calculate final rotation
  const segmentAngle = 45;
  const segmentOffset = segmentIndex * segmentAngle + segmentAngle / 2;
  const newRotation = currentRotation + (fullRotations * 360) + (360 - segmentOffset);

  // Animate wheel
  wheelSvg.style.transition = `transform ${WHEEL_CONFIG.rotationDuration}ms ${WHEEL_CONFIG.easingFunction}`;
  wheelSvg.style.transform = `rotate(${newRotation}deg)`;

  currentRotation = newRotation;

  // After animation completes
  setTimeout(() => {
    isSpinning = false;
    spinButton.classList.remove('spinning');

    // Display result in modal
    displayResult(prize);

    // Save to localStorage
    localStorage.setItem(STORAGE_KEY_PLAYED, 'true');
    localStorage.setItem(STORAGE_KEY_EMAIL, email);
    localStorage.setItem(STORAGE_KEY_PRIZE, JSON.stringify(prize));

    hasPlayed = true;
    updateButtonState();
  }, WHEEL_CONFIG.rotationDuration);
}

spinButton.addEventListener('click', spinWheel);

// Display result in modal based on prize type
function displayResult(prize) {
  modalContent.innerHTML = '';

  if (prize.type === 'code') {
    const discount = prize.discount || prize.text || '-15%';
    const code = prize.code || prize.subtext || 'LNA1';

    // Code promo modal
    const html = `
      <div class="lna-code-text">
        Tu repars avec ${discount} sur ta prochaine commande My Pretty Locks.
      </div>
      <div class="lna-code-display">${code}</div>
      <button class="lna-copy-button" id="lna-copy-btn">Copier le code</button>
    `;
    modalElement.classList.add('code-promo');
    modalElement.classList.remove('physical-prize');
    modalContent.innerHTML = html;

    // Copy button logic
    const copyBtn = document.getElementById('lna-copy-btn');
    copyBtn.addEventListener('click', () => {
      navigator.clipboard.writeText(code).then(() => {
        const originalText = copyBtn.textContent;
        copyBtn.textContent = 'Copié !';
        copyBtn.classList.add('copied');
        setTimeout(() => {
          copyBtn.textContent = originalText;
          copyBtn.classList.remove('copied');
        }, 2000);
      }).catch(() => {
        console.error('Failed to copy code');
      });
    });
  } else if (prize.type === 'physical') {
    // Physical prize modal
    const html = `
      <div class="lna-prize-name">${prize.name.toUpperCase()}</div>
      <div class="lna-instruction">
        Montre cet écran à l'équipe My Pretty Locks sur le stand pour récupérer ton lot.
      </div>
      <div class="lna-prize-badge">À récupérer sur le stand</div>
    `;
    modalElement.classList.add('physical-prize');
    modalElement.classList.remove('code-promo');
    modalContent.innerHTML = html;
  }

  openModal();
}

// Send to Mailchimp Worker (async, fire-and-forget)
function sendToMailchimp(email, firstName, prize) {
  const payload = {
    email,
    firstName,
    tag: 'LNA',
    prizeName: prize?.name || '',
    prizeType: prize?.type || '',
    discountCode: prize?.code || '',
    discountLabel: prize?.discount || '',
  };

  fetch(workerUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }).then(async (response) => {
    const responseText = await response.text();

    if (!response.ok) {
      console.error('Mailchimp worker error:', response.status, responseText);
      return;
    }

    console.info('Mailchimp worker success:', response.status, responseText);
  }).catch((err) => {
    // Silent failure — user experience not affected
    console.error('Mailchimp fetch error:', err);
  });
}

// Check if user already played (localStorage)
function checkPriorPlay() {
  const hasPlayedBefore = localStorage.getItem(STORAGE_KEY_PLAYED) === 'true';

  if (hasPlayedBefore) {
    hasPlayed = true;
    const priorPrize = localStorage.getItem(STORAGE_KEY_PRIZE);

    if (priorPrize) {
      try {
        const prize = JSON.parse(priorPrize);
        // Don't auto-open modal on page load; just disable button
        // User can click button to see their prior result if desired
      } catch (e) {
        console.error('Failed to parse prior prize:', e);
      }
    }

    updateButtonState();
  }
}

// Call on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  renderWheelSegments();
  checkPriorPlay();
  updateButtonState();
});
